import { render, staticRenderFns } from "./SEO.vue?vue&type=template&id=7286241c&"
import script from "./SEO.vue?vue&type=script&lang=js&"
export * from "./SEO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7286241c')) {
      api.createRecord('7286241c', component.options)
    } else {
      api.reload('7286241c', component.options)
    }
    module.hot.accept("./SEO.vue?vue&type=template&id=7286241c&", function () {
      api.rerender('7286241c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/SEO.vue"
export default component.exports